import { LoadingOutlined, SaveOutlined } from "@ant-design/icons";
import { Button } from "antd";
import type { ButtonProps } from "antd";

type SaveActionButtonProps = Omit<ButtonProps, "children" | "loading"> & {
  saving?: boolean;
  idleText?: string;
  savingText?: string;
};

/**
 * Shared save/update action button.
 * Future reference:
 * 1. Keeps saving feedback consistent across drawers, modals, and inline forms.
 * 2. Swaps label + spinner together so the UI clearly reflects in-flight saves.
 */
export const SaveActionButton = ({
  saving = false,
  idleText = "Save",
  savingText = "Saving...",
  disabled,
  icon,
  ...props
}: SaveActionButtonProps) => (
  <Button
    type="primary"
    {...props}
    disabled={disabled || saving}
    icon={saving ? <LoadingOutlined /> : (icon ?? <SaveOutlined />)}
  >
    {saving ? savingText : idleText}
  </Button>
);
